export default __webpack_public_path__ + "static/media/ialeap_alt_sf.6e2c367f.png";